import {Injectable} from '@angular/core';
import {StaticValuesUtils} from '../../utils/static-values/static-values.utils';
import {AppSettingsService} from '../app-settings/app-settings.service';

// Return the native window obj
function _window(): any {
    return window;
}

@Injectable({
    providedIn: 'root'
})
export class TimmingsService {

    private mainFeatureTime: number;

    constructor(private appSettingsService: AppSettingsService) {
    }

    private static get nativeWindow(): any {
        return _window();
    }

    trackMainFeature(data: any, uow: string, pageViewId: string, time?: number): void {
        this.mainFeatureTime = this.mainFeatureTime || Math.round(window.performance.now())
        if (TimmingsService.nativeWindow?.customTimmings?.trackMainFeature) {
            TimmingsService.nativeWindow.customTimmings.trackMainFeature(data, uow, pageViewId, this.mainFeatureTime);
        }
    }

    trackBounce(data: Map<string, string>, uow: string, pageViewId: string, time: number): void {
        if (TimmingsService.nativeWindow?.customTimmings?.trackBounce) {
            TimmingsService.nativeWindow.customTimmings.trackBounce(data, uow, pageViewId, time);
        }
    }

    trackTimings(listTimes: Map<string, number>, data: Map<string, string>, uow: string, pageViewId: string): void {
        if (TimmingsService.nativeWindow?.customTimmings?.trackTimings) {
            TimmingsService.nativeWindow.customTimmings.trackTimings(listTimes, data, uow, pageViewId);
        }
    }

    getDefaultTrackingData() {
        return {
            product: this.appSettingsService.getAppName(),
            abs: JSON.stringify(StaticValuesUtils.getABTests()),
            flow: 'SEARCH',
            channel: this.appSettingsService.getChannel(),
            userId: this.appSettingsService.getUserId(),
            locale: this.appSettingsService.getLocale(),
        };
    }
}
